var convert = require('./convert'),
    func = convert('flatMap', require('../flatMap'));

func.placeholder = require('./placeholder');
module.exports = func;



//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/lodash/fp/flatMap.js
// module id = 2399
// module chunks = 0